import qz from 'qz-tray'
import { sha256 } from './utils'

const today = new Date()
const DIGITAL_CERT_PATH = `/qz/digital-certificate.txt?cachebust=${today.getFullYear()}${today.getMonth()}${today.getDate()}` // we will bust the cache once per day. Note: getMonth returns a 0 indexed month
const SIGNER_PATH = `/print/qz_signer`

qz.websocket.setUsingSurf(false)

qz.security.setCertificatePromise((resolve, reject) => {
  fetch(DIGITAL_CERT_PATH)
    .then(r => r.text())
    .then(resolve, reject)
})

qz.security.setSignaturePromise(toSign => {
  return (resolve, reject) => {
    fetch(`${SIGNER_PATH}?request=${toSign}`)
      .then(r => r.text())
      .then(resolve, reject)
  }
})

qz.api.setPromiseType((resolver: any) => new Promise(resolver))
qz.api.setSha256Type((data: string) => sha256(data))

export default qz
